import React, { ReactNode, type JSX } from 'react';
import { Link } from 'react-router-dom';
import type { CommonProps } from '../../types';

export interface ButtonOrLinkProps extends CommonProps {
    onClick?: React.MouseEventHandler<Element>;
    href?: string;
    children?: ReactNode;
    target?: '_blank' | '_self' | '_parent' | '_top';
    type?: 'button' | 'submit' | 'reset' | undefined;
    internal?: boolean;
}

export const ButtonOrLink = ({
    href,
    testId = 'button-or-link',
    target,
    type,
    internal = false,
    ...props
}: ButtonOrLinkProps): JSX.Element => {
    if (internal) {
        return <Link to={href as string} {...props} />;
    }

    const ButtonOrAnchorTag = !href ? 'button' : 'a';

    let anchorTarget;

    const isExternalRegex = (url: string) => {
        const domainRe = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;

        return url.match(domainRe);
    };

    if (ButtonOrAnchorTag === 'a' && target) {
        anchorTarget = { target };
    } else if (typeof href === 'string' && isExternalRegex(href)) {
        anchorTarget = { target: '_blank' };
    }

    return (
        <ButtonOrAnchorTag
            data-testid={testId}
            href={href}
            type={type}
            {...anchorTarget}
            {...props}
        />
    );
};
